
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 74.083 74.083","height":"280","width":"280"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(-19.482 -73.533)","stroke-linecap":"round"}},[_c('circle',{attrs:{"cx":"46.974","cy":"101.006","r":"20.95","fill":"none","stroke":"#f5f5f5","stroke-width":"8","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M69.54 123.608l16.93 16.93","fill":"none","stroke":"#f5f5f5","stroke-width":"9.109"}}),_c('path',{attrs:{"d":"M26.396 121.584l41.156-41.156","fill":"red","stroke":"red","stroke-width":"12.307"}})])])
          )
        }
      }
    